import { useEffect, useState } from "react";
import { Button, Input, List, Modal, Space, Tag, message } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/PageHeader";
import { api } from "../../helpers/api";
import { errorMessage } from "../../helpers/api";
import { fmtMVR } from "../../helpers/format";
import { docTarget } from "../../helpers/docRoutes";
import { fetchPendingApprovals, type PendingApproval } from "../../helpers/approvals";

export default function ApprovalsInboxPage() {
  const [items, setItems] = useState<PendingApproval[]>([]);
  const [actioning, setActioning] = useState<PendingApproval | null>(null);
  const [approve, setApprove] = useState(true);
  const [comment, setComment] = useState("");
  const navigate = useNavigate();

  async function load() {
    setItems(await fetchPendingApprovals());
  }

  useEffect(() => {
    load();
  }, []);

  function openAction(item: PendingApproval, isApprove: boolean) {
    setActioning(item);
    setApprove(isApprove);
    setComment("");
  }

  async function submitAction() {
    if (!actioning) return;
    try {
      await api.post(`/approvals/${actioning.instance.documentType}/${actioning.instance.documentId}/${approve ? "approve" : "reject"}`, { comment });
      message.success(approve ? "Approved." : "Rejected.");
      setActioning(null);
      load();
    } catch (err) {
      message.error(errorMessage(err));
    }
  }

  return (
    <div>
      <PageHeader title="Approvals" />
      <List
        dataSource={items}
        data-tour="approvals-list"
        locale={{ emptyText: "Nothing awaiting your approval." }}
        renderItem={(item) => {
          const target = docTarget(item.instance.documentType, item.instance.documentId);
          return (
            <List.Item
              actions={[
                <Button key="approve" icon={<CheckOutlined />} type="primary" onClick={() => openAction(item, true)}>
                  Approve
                </Button>,
                <Button key="reject" icon={<CloseOutlined />} danger onClick={() => openAction(item, false)}>
                  Reject
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  target ? (
                    <a onClick={() => navigate(target.path)} data-tour="approval-doc-link">
                      {item.docNo}
                    </a>
                  ) : (
                    item.docNo
                  )
                }
                description={
                  <Space>
                    <Tag>{item.instance.documentType.replaceAll("_", " ")}</Tag>
                    {item.amountLaari != null && <span>{fmtMVR(item.amountLaari)}</span>}
                  </Space>
                }
              />
            </List.Item>
          );
        }}
      />
      <Modal
        title={approve ? "Approve" : "Reject"}
        open={!!actioning}
        onCancel={() => setActioning(null)}
        onOk={submitAction}
        okButtonProps={{ danger: !approve }}
      >
        <Input.TextArea rows={3} placeholder="Comment (optional)" value={comment} onChange={(e) => setComment(e.target.value)} />
      </Modal>
    </div>
  );
}
